module.exports = __webpack_public_path__ + "img/presedia.ec222a74.png";